import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTextBox = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 25,
	height: 24,
	viewBox: "0 0 25 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M3.33398 12C3.33398 5 5.33491 3 12.3344 3C19.334 3 21.334 5 21.334 12C21.334 19 19.2571 21 12.3344 21C5.41183 21 3.33398 19 3.33398 12Z",
			stroke: "#8A94A6",
			strokeWidth: 1.6,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11.534 15C11.534 15.4418 11.8922 15.8 12.334 15.8C12.7758 15.8 13.134 15.4418 13.134 15H11.534ZM9.33398 8.2C8.89216 8.2 8.53398 8.55817 8.53398 9C8.53398 9.44183 8.89216 9.8 9.33398 9.8V8.2ZM15.334 9.8C15.7758 9.8 16.134 9.44183 16.134 9C16.134 8.55817 15.7758 8.2 15.334 8.2V9.8ZM11.534 9V15H13.134V9H11.534ZM12.334 8.2H9.33398V9.8H12.334V8.2ZM12.334 9.8H15.334V8.2H12.334V9.8Z",
			fill: "#8A94A6"
		})
	]
});
const ForwardRef = forwardRef(SvgTextBox);
export { ForwardRef as ReactComponent };
